import { Component, OnInit } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

declare var alertify: any;

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  private Parse: any = require('parse');

  model: any = { };

  constructor(
    public http: Http,
    public apiService: ApiService,
    private router: Router,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();
  }

  passwordReset() {
    let $this = this;
    let headers = new Headers();

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);

    let options = new RequestOptions({ headers: headers });
    let payload = {
      'email': this.model.username
    }

    return this.http.post(this.apiService.Parse.serverURL + '/requestPasswordReset', payload, options)
      .map(response => response.json()).subscribe(
      response => {
        alertify.alert('A password reset email has been sent to ' + this.model.username + '.', function (e) {
          if (e) {
            $this.router.navigate(['/login']);
          } else {
            return false;
          }
        });
      },
      error => alertify.error(error.message)
    );
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/password-reset/password-reset.component.ts